const inquiryEndpoints = {
    addInquiry: {
        method:"POST",
        url:`/inquiry`
    },
    updateInquiry: (id) => ({
        method:"DELETE",
        url:`/inquiry/${id}`
    })  
};

export default inquiryEndpoints